import React from 'react';
import Utilities from '@util/Utilities';
import SectionPlaceholder from '@app/component/placeholder/SectionPlaceholder';
import _isEmpty from 'lodash/isEmpty';
import CalendarMonth from '@app/state/calendar/CalendarMonth';
import { ClockIcon } from '@heroicons/react/24/outline';
import {
	useMarketStateTools,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/hook/useMarketStateTools';

const MarketStateSnapshotUpdateDate: React.FunctionComponent<{
	calendarMonth: CalendarMonth, hideSeperator?: boolean;
}> = ({ calendarMonth, hideSeperator }) => {

	const { marketStateSnapshot } = useMarketStateTools();

	if (!!marketStateSnapshot && !_isEmpty(marketStateSnapshot.latestUpdateDatePerMonth)) {
		const latestUpdateDatePerMonth = marketStateSnapshot.latestUpdateDatePerMonth.find(entry => entry.month === calendarMonth.index.month);

		if (!!latestUpdateDatePerMonth)
			return <>
			<span className="text-xs text-gray-400 flex">
            <SectionPlaceholder
							timeout={1000}><span className="mr-1"><ClockIcon
							className="w-4 h-4" /></span><span>{`Updated ${Utilities.timeDifference(latestUpdateDatePerMonth.lastUpdateDate)} ago`}</span></SectionPlaceholder>
        </span>
				{!hideSeperator && <div className="h-6 w-px bg-gray-300 mx-4 hidden sm:block" />}
			</>;

	}

	return <></>;
};


export default MarketStateSnapshotUpdateDate;